/* eslint-disable import/prefer-default-export */
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;
